import styled from "styled-components";

export const Container = styled.div`
  margin: 0px 136px 50px 136px;
`;
